<div style="grid-column: 1 / -1; display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px; margin-bottom: 20px;">

  <div>
    <p class="dark-blue no-margin mb-5">Dénomination du collège <span class="red">*</span></p>
    <select class="text-md dark-blue title-input"
      style="width: 100%; max-width: 100%; overflow: hidden; text-overflow: ellipsis;"
      [(ngModel)]="college.collegeType[0]" (ngModelChange)="onCollegesChange()">
      <option value="" disabled selected>Sélectionner un type</option>
      <option *ngFor="let type of collegeTypeOptions" [value]="type">{{type}}</option>
    </select>
  </div>

  <div>
    <p class="dark-blue no-margin mb-5">Libellé du collège <span class="red">*</span></p>
    <input type="text" name="label" id="college-label" class="pap-input w-full" [(ngModel)]="college.collegeName"
      (ngModelChange)="onCollegesChange()">
  </div>

  <div style="grid-column: 1 / -1;">
    <p class="dark-blue no-margin mb-5">Composition précise <span class="red">*</span></p>
    <div class="flex content-between mb-10"
      style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px; margin-bottom: 20px;">
      <label class="flex align-items-center gap-5 pointer dark-blue">
        <input type="checkbox" [checked]="isCompositionSelected(lineupOptions.Workers)"
          (change)="toggleComposition(lineupOptions.Workers)"> Ouvriers
      </label>
      <label class="flex align-items-center gap-5 pointer dark-blue">
        <input type="checkbox" [checked]="isCompositionSelected(lineupOptions.Employees)"
          (change)="toggleComposition(lineupOptions.Employees)"> Employés
      </label>
      <label class="flex align-items-center gap-5 pointer dark-blue">
        <input type="checkbox" [checked]="isCompositionSelected(lineupOptions.Technicians)"
          (change)="toggleComposition(lineupOptions.Technicians)"> Techniciens
      </label>
      <label class="flex align-items-center gap-5 pointer dark-blue">
        <input type="checkbox" [checked]="isCompositionSelected(lineupOptions.Supervisors)"
          (change)="toggleComposition(lineupOptions.Supervisors)"> Agent de maîtrise
      </label>
      <label class="flex align-items-center gap-5 pointer dark-blue">
        <input type="checkbox" [checked]="isCompositionSelected(lineupOptions.Engineers)"
          (change)="toggleComposition(lineupOptions.Engineers)"> Ingénieur
      </label>
      <label class="flex align-items-center gap-5 pointer dark-blue">
        <input type="checkbox" [checked]="isCompositionSelected(lineupOptions.Executives)"
          (change)="toggleComposition(lineupOptions.Executives)"> Cadres
      </label>
      <div class="flex gap-10" style="grid-column: span 2;">
        <label class="flex align-items-center gap-5 pointer dark-blue" style="white-space: nowrap;">
          <input type="checkbox" [checked]="isCompositionSelected(lineupOptions.Other)"
            (change)="toggleComposition(lineupOptions.Other)"> Autres (préciser) :
        </label>
        <input type="text" class="text-md dark-blue title-input" [(ngModel)]="college.detail"
          (ngModelChange)="onCollegesChange()">
      </div>
    </div>
  </div>

  <div>
    <p class="dark-blue no-margin mb-5">Siège titulaires <span class="red">*</span></p>
    <input [(ngModel)]="college.seats" (ngModelChange)="onCollegesChange()" (wheel)="$event.preventDefault()"
      type="number" name="seats" id="seats" min="0" class="w-full text-md dark-blue pap-input"
      value="{{college.seats}}">
  </div>

  <div>
    <p class="dark-blue no-margin mb-5">Siège suppléants <span class="red">*</span></p>
    <input [(ngModel)]="college.substituteSeats" (ngModelChange)="onCollegesChange()" (wheel)="$event.preventDefault()"
      type="number" name="substituteSeats" id="substituteSeats" min="0" class="w-full text-md dark-blue pap-input"
      value="{{college.substituteSeats}}" [disabled]="!partial">
  </div>

  <p style="grid-column: 1 / -1;" class="dark-blue no-margin mb-5 bold">
    <span class="circle"></span>Effectif et répartition par sexe
  </p>
  <div style="grid-column: 1 / -1;">
    <div class="flex content-between mb-10"
      style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-bottom: 20px;">
      <div>
        <p class="dark-blue no-margin mb-5">Effectif du collège <span class="red">*</span></p>
        <input type="number" (wheel)="$event.preventDefault()" name="lineup" id="college-lineup" min="0"
          class="pap-input w-full" [ngClass]="{'error-border': hasGenderError || remainingEmployee < 0}"
          [(ngModel)]="college.lineup" (ngModelChange)="onCollegesChange()">
        <p class="text-xs dark-gray">Salariés à attribuer : <span class="bold"
            [ngClass]="{'dark-red': remainingEmployee != 0}">{{remainingEmployee}}</span></p>
      </div>
      <div>
        <p class="dark-blue no-margin mb-5">Effectif Femmes <span class="red">*</span></p>
        <input type="number" (wheel)="$event.preventDefault()" name="women" id="college-women" min="0"
          class="pap-input w-full" [ngClass]="{'error-border': hasGenderError}" [max]="college.lineup"
          [(ngModel)]="college.genderDistribution[0]" (ngModelChange)="onCollegesChange()">
      </div>
      <div>
        <p class="dark-blue no-margin mb-5">Effectif Hommes <span class="red">*</span></p>
        <input type="number" (wheel)="$event.preventDefault()" name="men" id="college-men" class="pap-input w-full"
          [value]="calculatedMenCount" [(ngModel)]="college.genderDistribution[1]" disabled>
      </div>
    </div>
  </div>

  <div>
    <p class="dark-blue no-margin mb-5">Pourcentage Femmes <span class="red">*</span></p>
    <input type="number" (wheel)="$event.preventDefault()" name="women-percentage" id="women-percentage"
      class="pap-input w-full" [value]="womenPercentage" disabled>
  </div>
  <div>
    <p class="dark-blue no-margin mb-5">Pourcentage Hommes <span class="red">*</span></p>
    <input type="number" (wheel)="$event.preventDefault()" name="men-percentage" id="men-percentage"
      class="pap-input w-full" [value]="menPercentage" disabled>
  </div>

  <p style="grid-column: 1 / -1;" class="dark-blue no-margin mb-5 bold">
    <span class="circle"></span>Proportions titulaires
  </p>
  <!-- <div style="grid-column: 1 / -1;" class="p-30 bg-pastel-blue">
    <p class="no-margin dark-blue">
      Sièges à pourvoir (titulaires) : {{college.seats}}
    </p>
    <p class="no-margin dark-blue">
      % Femmes : {{womenPercentage}} | % Hommes : {{menPercentage}}
    </p>
  </div> -->

  <div>
    <p class="dark-blue no-margin mb-5">Proportion Femmes <span class="red">*</span></p>
    <input type="number" (wheel)="$event.preventDefault()" name="women-seats-percentage" id="women-seats-percentage"
      min="0" class="pap-input w-full" [(ngModel)]="college.proportion[0]" [disabled]="seatsSuggestionChecked"
      [value]="displayedWomenProportion" (ngModelChange)="onCollegesChange()">
    <div class="flex align-items-center gap-10">
      <input type="checkbox" name="seatsSuggestion" id="suggestion" [(ngModel)]="seatsSuggestionChecked"
        (ngModelChange)="onSeatsSuggestionChange()" class="pointer">
      <p class="dark-gray text-xs">
        Utiliser les valeurs suggérées : <span class="bold">{{womenSeatsSuggested}} et {{menSeatsSuggested}}</span>
      </p>

    </div>
  </div>
  <div>
    <p class="dark-blue no-margin mb-5">Proportion Hommes <span class="red">*</span></p>
    <input type="number" (wheel)="$event.preventDefault()" name="men-seats-percentage" id="men-seats-percentage" min="0"
      class="pap-input w-full" [(ngModel)]="college.proportion[1]" [disabled]="seatsSuggestionChecked"
      [value]="displayedMenProportion" (ngModelChange)="onCollegesChange()">
  </div>

  <p style="grid-column: 1 / -1;" class="dark-blue no-margin mb-5 bold">
    <span class="circle"></span>Proportions suppléants
  </p>
  <!-- <div style="grid-column: 1 / -1;" class="p-30 bg-pastel-blue">

    <p class="no-margin dark-blue">
      Sièges à pourvoir (suppléants) : {{college.substituteSeats}}
    </p>
    <p class="no-margin dark-blue">
      % Femmes : {{womenPercentage}} | % Hommes : {{menPercentage}}
    </p>
  </div> -->

  <div>
    <p class="dark-blue no-margin mb-5">Proportion Femmes <span class="red">*</span></p>
    <input type="number" (wheel)="$event.preventDefault()" name="women-substitutes-percentage"
      id="women-substitutes-percentage" class="pap-input w-full" (ngModelChange)="onCollegesChange()"
      [(ngModel)]="college.substituteProportion[0]" [disabled]="substitutesSeatsSuggestionChecked"
      [value]="displayedWomenSubstituteProportion">
    <div class="flex align-items-center gap-10">
      <input type="checkbox" name="substitutesSeatsSuggestion" id="substituteSuggestion" [(ngModel)]="substitutesSeatsSuggestionChecked"
        (ngModelChange)="onSeatsSuggestionChange()" class="pointer">
      <p class="dark-gray text-xs">
        Utiliser les valeurs suggérées : <span class="bold">{{womenSubstituteSeatsCount}} et {{menSubstituteSeatsCount}}</span>
      </p>

    </div>
  </div>
  <div>
    <p class="dark-blue no-margin mb-5">Proportion Hommes <span class="red">*</span></p>
    <input type="number" (wheel)="$event.preventDefault()" name="men-substitutes-percentage"
      id="men-substitutes-percentage" class="pap-input w-full"
      [(ngModel)]="college.substituteProportion[1]" [disabled]="substitutesSeatsSuggestionChecked"
      [value]="displayedMenSubstituteProportion" (ngModelChange)="onCollegesChange()">
  </div>

  <p style="grid-column: 1 / -1;" class="dark-blue no-margin mb-5 bold">
    <span class="circle"></span>Ce scrutin fait-il suite à une décision de justice annulant un précédent scrutin ?
  </p>
  <div style="grid-column: 1 / -1;" class="flex gap-10">
    <label class="flex align-items-center gap-5 pointer dark-blue">
      <input type="radio" name="cancelled - {{index}}" [value]="true" [(ngModel)]="hasCourtDecision" (ngModelChange)="onCourtDecisionChange()"> Oui
    </label>
    <label class="flex align-items-center gap-5 pointer dark-blue">
      <input type="radio" name="cancelled - {{index}}" [value]="false" [(ngModel)]="hasCourtDecision" (ngModelChange)="onCourtDecisionChange()"> Non
    </label>
  </div>
  <div *ngIf="hasCourtDecision" style="grid-column: 1 / -1;">
    <p class="dark-blue no-margin">Date du scrutin annulé <span class="red">*</span></p>
    <div>
      <input type="date" name="first_close" id="first_close" class="text-md dark-blue pap-input" [max]="maxDate"
        [(ngModel)]="cancelledElectionDate">
    </div>
  </div>

</div>